import Vue from "vue";
import vlink from "@/components/ui/Vlink";

Vue.component("v-link", vlink);
